import { StableChildren } from '@prophecy/utils/react/StableChildren';
import React, { useContext } from 'react';

import { useCodeGenContext } from './useCodeGenContext';

const CodeGenerationContext = React.createContext<ReturnType<typeof useCodeGenContext> | null>(null);
export function useCodeGenerationState() {
  return useContext(CodeGenerationContext) as ReturnType<typeof useCodeGenContext>;
}

export function CodeGenerationContextProvider({
  children,
  isPipelineIDE = false
}: {
  children: React.ReactNode;
  isPipelineIDE?: boolean;
}) {
  const codeGenContextValue = useCodeGenContext({ isPipelineIDE });
  return (
    <CodeGenerationContext.Provider value={codeGenContextValue}>
      <StableChildren>{children}</StableChildren>
    </CodeGenerationContext.Provider>
  );
}
